import { QUEUE_MESSAGE_MAX_BYTES } from '../../types/azureStorage';

export type QueueMessageEncodeResult =
  | { ok: true; body: string; bytes: number }
  | { ok: false; reason: string };

export type QueueMessageDecodeResult = { text: string; invalid?: 'not-base64' };

const encoder = new TextEncoder();
const decoder = new TextDecoder('utf-8', { fatal: true });

export function queueMessageByteLength(value: string): number {
  return encoder.encode(value).byteLength;
}

function bytesToBase64(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary);
}

function base64ToBytes(value: string): Uint8Array {
  const binary = atob(value);
  return Uint8Array.from(binary, (character) => character.charCodeAt(0));
}

export function looksLikeBase64(value: string): boolean {
  if (value.length === 0 || value.length % 4 !== 0 || !/^[A-Za-z0-9+/]+={0,2}$/.test(value)) return false;
  try {
    return bytesToBase64(base64ToBytes(value)) === value;
  } catch {
    return false;
  }
}

export function encodeQueueMessageText(text: string, mode: 'text' | 'base64'): QueueMessageEncodeResult {
  if (text.length === 0) return { ok: false, reason: 'Queue messages cannot be empty.' };
  const body = mode === 'base64' ? bytesToBase64(encoder.encode(text)) : text;
  const bytes = queueMessageByteLength(body);
  if (bytes > QUEUE_MESSAGE_MAX_BYTES) {
    return { ok: false, reason: 'Queue messages can be at most 64 KiB after encoding.' };
  }
  return { ok: true, body, bytes };
}

export function decodeQueueMessageText(body: string, decodeBase64: boolean): QueueMessageDecodeResult {
  if (!decodeBase64) return { text: body };
  if (!looksLikeBase64(body)) return { text: body, invalid: 'not-base64' };
  try {
    return { text: decoder.decode(base64ToBytes(body)) };
  } catch {
    return { text: body, invalid: 'not-base64' };
  }
}
